import { useDispatch } from 'hooks/utils';
import { useActivity } from 'hooks/store';
import { Operation } from 'hooks/store/types';
import { ActionTypes, createRole } from 'store/data/roles';

type HandlerInput = Parameters<typeof createRole>;

export function useCreateRole(): Operation<(...input: HandlerInput) => void> {
	const dispatch = useDispatch();

	const [{ loading, error }, resetError] = useActivity(ActionTypes.CREATE_ROLE);

	function handler(...input: HandlerInput) {
		if (loading) return;
		if (error) resetError();

		dispatch(createRole(...input));
	}

	return [{ loading, error }, handler];
}
